<div class="rollover-status">
  <div [ngClass]="'rollover-status-left rollover-status-left__' + content.tier">
    <div class="rollover-status-left__name">
      {{ content.name }}
    </div>
    <div class="rollover-status-left__level">
      {{ content.level.title + content.level.subtitle }}
      <div>
        <button
          auraTooltip
          [template]="customTooltip"
          [tooltipContent]="{
            info: ''
          }"
          class="rollover-status-left__level__icon"
        >
          <img
            [alt]="content.ariaLabel.info"
            class="rollover-status-left__level__icon-img"
          />
        </button>
        <ng-template #customTooltip>
          <div class="custom-tooltip__text">
            {{ content.info }}
          </div>
        </ng-template>
      </div>
    </div>
  </div>

  <div
    [ngClass]="'rollover-status-right rollover-status-right__' + content.tier"
  >
    <ng-container *ngIf="content.details.success; else default">
      <div class="rollover-status-right__success-label">
        <div
          class="rollover-status-right__success-label__icon"
          aria-hidden="true"
        ></div>
        <div class="rollover-status-right__success-label__title">
          {{ content.details.success }}
        </div>
      </div>
      <div class="rollover-status-right__success__divider">
        <aura-divider></aura-divider>
      </div>

      <div
        *ngFor="let selection of content.details.selections; let last = last"
      >
        <div class="rollover-status-right__success">
          <div class="rollover-status-right__success__title">
            {{ selection.title }}
          </div>

          <div class="rollover-status-right__success__value">
            {{ selection.subtitle }}
          </div>
          <div *ngIf="!last" class="rollover-status-right__success__divider">
            <aura-divider></aura-divider>
          </div>
        </div>
      </div>
    </ng-container>
    <ng-template #default>
      <div class="rollover-status-right__balance__title">
        {{ content.details.balance?.title }}
      </div>
      <div class="rollover-status-right__balance__value">
        {{ content.details.balance?.miles }}
      </div>
    </ng-template>
  </div>
</div>
